export const DEFAULT_VIDEO_ASPECT_MODE = 'Fit Horizontally';

/** Plane size from native video aspect + editor aspect-ratio mode (shared by upload, load, publish). */
export function calculateVideoPlaneDimensions(
  videoAspect,
  aspectRatioMode = DEFAULT_VIDEO_ASPECT_MODE
) {
  const aspect = Number(videoAspect);
  const safeAspect = Number.isFinite(aspect) && aspect > 0 ? aspect : 1;

  let planeWidth = 1;
  let planeHeight = 1;

  switch (aspectRatioMode) {
    case 'Fit Horizontally':
      planeWidth = 1;
      planeHeight = 1 / safeAspect;
      break;
    case 'Fit Vertically':
      planeWidth = safeAspect;
      planeHeight = 1;
      break;
    case 'Stretch':
      planeWidth = 1;
      planeHeight = 1;
      break;
    case '16:9':
      planeWidth = 16 / 9;
      planeHeight = 1;
      break;
    case '4:3':
      planeWidth = 4 / 3;
      planeHeight = 1;
      break;
    default:
      planeWidth = 1;
      planeHeight = 1 / safeAspect;
  }

  return { planeWidth, planeHeight };
}

/** Prefer persisted plane size from publish; fall back to aspect mode calculation. */
export function resolveVideoPlaneDimensions({
  videoAspect,
  aspectRatioMode = DEFAULT_VIDEO_ASPECT_MODE,
  savedPlaneWidth,
  savedPlaneHeight,
}) {
  const savedW = Number(savedPlaneWidth);
  const savedH = Number(savedPlaneHeight);
  if (savedW > 0 && savedH > 0) {
    return { planeWidth: savedW, planeHeight: savedH };
  }
  return calculateVideoPlaneDimensions(videoAspect, aspectRatioMode);
}

/** Bake mesh scale for API persistence (plane size × mesh scale, same as images/audio). */
export function videoMeshScaleToSavedScale(meshScale, planeWidth, planeHeight) {
  const pw = Number(planeWidth) > 0 ? Number(planeWidth) : 1;
  const ph = Number(planeHeight) > 0 ? Number(planeHeight) : 1;
  return {
    scale_x: pw * (meshScale?.x ?? 1),
    scale_y: ph * (meshScale?.y ?? 1),
    scale_z: meshScale?.z ?? 1,
  };
}

/** Convert persisted video scale back to Three.js mesh scale on load. */
export function videoSavedScaleToMeshScale(
  scale_x,
  scale_y,
  scale_z,
  planeWidth,
  planeHeight
) {
  const pw = Number(planeWidth) > 0 ? Number(planeWidth) : 1;
  const ph = Number(planeHeight) > 0 ? Number(planeHeight) : 1;
  return {
    x: (scale_x ?? 1) / pw,
    y: (scale_y ?? 1) / ph,
    z: scale_z ?? 1,
  };
}
